import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  leftArrow: {
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
